import type { AxiosError, AxiosResponse } from "axios";
import type { GetAuditTrailInput, ServiceAuditTrailEntry } from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_AUDIT_BASE_URL;

export const getAuditTrail = async ({
  serviceId,
  serviceType,
}: GetAuditTrailInput): Promise<ServiceAuditTrailEntry[]> => {
  try {
    const response = await axiosClient.get(
      `${BASE_URL}/audit_trail/service/${serviceType}/${serviceId}`,
    );
    const resData = response.data;
    if (!resData.success) {
      throw response;
    }
    return (resData.data ?? []) as ServiceAuditTrailEntry[];
  } catch (error) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};
